import store from "@/vuex/store";
/*
This directive can be of two forms 
1. v-quill-html:videoObjectPropname="html"
2. v-quill-html:videoObjectPropname.src="url or key to look for inside dynamic strings array in vuex store | suffix(eg:html,formattedBody default is `html`)" eg: default  : 11124154 will be  11124154_html or pass 11124154|formattedBody for 11124154_formattedBody
Where videoObjectPropname is the participant videos Object from bitrise data which can be get from vuex getter "getParticipantStudyVideos"
if .src modifier is applied value must be a url which will be loaded and parsed then the inner html will be appended to the el

overall whichever the final HTML this directive looks for the specific url (/video/{videoId}/emptyvideourl) pattern for the iframe in that html and replaces it with the 
provided video url in bitrise videos object
*/
const quillHtmlDirective = () => {
  const processHtml = (htmlData, videos) => {
    const replaceFn = (src, p1, quoteChar) => {
      let newSrc = src;
      try {
        const id = src.split("/video/")[1].split("/emptyvideourl")[0];
        if (videos[id]) {
          newSrc = p1 + "autoplay=false " + "src=" + quoteChar + videos[id];
        }
        return newSrc;
      } catch (err) {
        return src;
      }
    };
    const html = htmlData;
    let regEx = /(<iframe.+?)src\s{0,}=\s{0,}"(.*?)(?=")/g;
    let html1 = html.replace(regEx, (src, p1) => replaceFn(src, p1, '"'));
    regEx = /(<iframe.+?)src\s{0,}=\s{0,}'(.*?)(?=')/g;
    html1 = html1.replace(regEx, (src, p1) => replaceFn(src, p1, "'"));
    return html1;
  };
  const isValidHttpUrl = string => {
    let url;

    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
  };
  const setUpInnerHtml = (htmlOld, el, binding, node) => {
    let html = htmlOld;
    try {
      const videos = node.context[binding.arg];
      html = processHtml(html, videos);
    } catch (err) {}
    el.innerHTML = html;
  };
  const binder = async (el, binding, node) => {
    if (binding.modifiers.src) {
      let html = el.innerHTML;
      const boundValueParts = binding.value.split("|");
      const key = boundValueParts[0];
      let url = key;
      if (!isValidHttpUrl(url)) {
        const suffix = boundValueParts.length > 1 ? boundValueParts[1] : "html";
        if (store.getters.getParticipantsActivityTranslation && store.getters.getParticipantsActivityTranslation[`${key}_${suffix}`]) {
          html = store.getters.getParticipantsActivityTranslation[`${key}_${suffix}`].v;
          url = null;
        } else {
          url = store.getters.getParticipantsPortalBitriseData && store.getters.getParticipantsPortalBitriseData.listOfSignedHTMLURL && store.getters.getParticipantsPortalBitriseData.listOfSignedHTMLURL[key] ? store.getters.getParticipantsPortalBitriseData.listOfSignedHTMLURL[key] : null;
        }
      }
      if (url) {
        const response = await fetch(url);
        const text = await response.text();
        const dom = new DOMParser().parseFromString(text, "text/html");
        html = dom.body.innerHTML;
      }
      return setUpInnerHtml(html, el, binding, node);
    } else {
      setUpInnerHtml(binding.value, el, binding, node);
    }
  };
  return {
    bind: (el, binding, node) => {
      binder(el, binding, node);
    },
    update: (el, binding, node) => {
      binder(el, binding, node);
    },
    processHtml: (html, videos) => {
      processHtml(html, videos);
    }
  };
};
export default quillHtmlDirective;
